var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyBuilding = function SvgCompanyBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 22h6V11h-6M11.429 2H3.714A1.714 1.714 0 0 0 2 3.714V22h14V7M6 7h6M6 12h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.2 17H7.8c-.442 0-.8.373-.8.833v3.334c0 .46.358.833.8.833h2.4c.442 0 .8-.373.8-.833v-3.334c0-.46-.358-.833-.8-.833M11.286 2h3A1.714 1.714 0 0 1 16 3.714V7"
  })));
};
export default SvgCompanyBuilding;